import React, { Component } from 'react';
import '../Partials/App.scss';
import Header from './Header';
import axios from 'axios';
import RepTemplates from './RepTemplates';
import Footer from './Footer';

class App extends Component {
  constructor() {
    super();
    this.state = {
      postalCode: '',
      apiData: [],
      isPostalCodeWrong: false,
      latAndLng: '',
    }
  }

  // handleChange will track the user's postal code input and make sure it has no spaces. It will also conver it to uppercase, which is a requirement for the Open North API.

  handleChange = (event) => {
    this.setState({
      postalCode: event.target.value.replace(/\s/g, '').toUpperCase(),
    });
  }

  // handleSubmit will take the user's postal code and feed it into the getCoordinates function as a parameter. First it will test the code against the regex pattern, and if it is successful it will call the getCoordinates function with that postal code. If it does not pass the regex test, it will set the state of "isPostalCodeWrong" to "yes."

  handleSubmit = (event) => {
    event.preventDefault();
    const postalTest = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    if (postalTest.test(this.state.postalCode)) {
      this.getCoordinates(this.state.postalCode);
      this.setState({
        isPostalCodeWrong: false,
      });
    }
    else {
      this.setState({
        isPostalCodeWrong: true,
      })
    }
  }

  // this function will take the user's postal code from state and add it as a parameter to the MapQuest API. When the data comes back, we are extracting the latitude (lat) and longitude (lng), then storing them in state using a template expression.

  getCoordinates = (postalCode) => {
    axios({
      method: 'GET',
      dataResponse: 'JSON',
      url: 'https://www.mapquestapi.com/geocoding/v1/address',
      params: {
        key: '0e6fiTKnDmzM3WFno2NIq25f3mKTXGQw',
        location: this.state.postalCode,
      }
    }).then((results) =>{
      let lat = results.data.results[0].locations[0].latLng.lat;
      let lng = results.data.results[0].locations[0].latLng.lng;
    this.setState({
      latAndLng: `${lat},${lng}`,
    });
    }
    ).then(()=>{
      this.requestRep(this.state.latAndLng);
    })}

    //this function will take the stored latitude and longitude from state and use them as parameters to call the Open North API. Once the data is retrieved, we are storing the parts we want in state (repData).
  
  requestRep = (latAndLng) => {
    axios({
      method: 'GET',
      url: 'https://proxy.hackeryou.com',
      dataResponse: 'json',
      params: {
        reqUrl: `https://represent.opennorth.ca/representatives/?point=${latAndLng}`,
      },
      xmlToJSON: false
    }).then((res) => {
      const repData = res.data.objects;
      this.setState({
        apiData: repData,
      });
      // Note: The API does not send us back a response when there is an error, so ufortunately the .catch method does not work at this time. However, there is already some error handling in place that will make sure the user enters a valid postal code, such as toUpperCase() and the regex test seen below.

      setTimeout(this.smoothScroll, 400) // smoothScroll function will run over 400 miliseconds
    });
  }

  smoothScroll = () => {
    let destination = document.getElementById('repContainer');
    destination.scrollIntoView({
      behavior: 'smooth', 
      block: 'start' 
    });
  }


  render(){
  return (
    <div className="App">
    <Header />
    {/* this is the input and submit button */}
      <div className="searchField wrapper">
        <form onSubmit={this.handleSubmit}>
          <label htmlFor="postalCodeInput" className="visuallyHidden">Postal Code</label>
          <input
            type="text"
            name="postalCode"
            onChange={this.handleChange}
            value={this.postalCode} />
            {/* The p element below will render if the postal code does not pass the regex test*/}
            {this.state.isPostalCodeWrong ? <p className="postalError">Oops! That's not a valid postal code.</p> : null}
          <button type="submit">Rep me!</button>
        </form>
      </div>
    <RepTemplates arrayData={this.state.apiData}/>
    <Footer />
    </div>
  );
  }
}

export default App;
